export default function GuideCTA() {
  return (
    <section className="w-full flex justify-center mt-10 mb-16">
      <div className="relative w-[90%] max-w-[1100px] rounded-xl overflow-hidden bg-gray-100">
        <img
          src="/assets/images/guide-bg.png"
          alt="Guide Background"
          className="absolute inset-0 w-full h-full object-cover"
        />

        <div className="absolute inset-0 bg-white/50" />

        <div className="relative z-10 flex flex-col items-center justify-center py-12 text-center">
          <h2 className="text-2xl md:text-3xl font-semibold text-gray-900 mb-6">
            Need help sourcing your next product?
          </h2>
          <button className="bg-rose-700 hover:bg-rose-800 text-white px-6 py-3 rounded-lg text-lg font-medium shadow-md transition">
            View Guide →
          </button>
        </div>
      </div>
    </section>
  );
}
